import React, { useMemo } from 'react'
import './PropostaAbas.css'
import { useState, useEffect } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import oikosApi from '../../../services/oikos';
import qs from 'qs';
import { Button, Card, CardBody, CardHeader, FormGroup, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap';
import Select from '../../../components/Template/Input/Select';
import MaskedInput from '../../../components/Template/Input/MaskedInput';
import currencyFormatter from '../../../utils/currencyFormatter';
import MaterialReactTable from 'material-react-table';
import { useParams } from 'react-router-dom/cjs/react-router-dom';

function NovaPropostaEmBranco() {
  const [activeId, setActiveId] = useState('');
  const [prodsProp, setProdsProp] = useState([]);
  const [eventosPagamentoProp, setEventosPagamentoProp] = useState([]);
  const [eventoPagamentoPropData, setEventoPagamentoPropData] = useState([]);
  const [propItens, setPropItens] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [modalPropItemOpen, setModalPropItemOpen] = useState(false);
  const [modalProdPropOpen, setModalProdPropOpen] = useState(false);
  const [modalEventosPagamentoOpen, setModalEventosPagamentoOpen] = useState(false);
  const [propItemData, setPropItemData] = useState({});
  const [propostaData, setPropostaData] = useState({});
  const [prodPropData, setProdPropData] = useState({});
  const [isSubmitEntityLoading, setIsSubmitEntityLoading] = useState(false);
  const [isEditingProdProp, setIsEditingProdProp] = useState(false);
  const [isEditingEventoPagamentoProp, setIsEditingEventoPagamentoProp] = useState(false);
  const [modalPropItemEditOpen, setModalPropItemEditOpen] = useState(false);
  const { id } = useParams();
  const [visaoGeralPercentuais, setVisaoGeralPercentuais] = useState({
    comissao: 0,
    custoFinanceiro: 0,
    taxaAdm: 0,
    remuneracaoEmpresa: 0,
  });
  const [visaoGeralMesesQtd, setVisaoGeralMesesQtd] = useState(0);

  const parseNumericValue = (value) => {
    if (value === null || value === undefined) return null;

    const raw = String(value).trim();
    if (!raw) return null;

    const cleaned = raw.replace("%", "").replace(/\s/g, "");

    // Handles both pt-BR (`1.234,56`) and unmasked (`1234.56`) shapes
    let normalized = cleaned;
    const hasComma = normalized.includes(",");
    const hasDot = normalized.includes(".");

    if (hasComma && hasDot) {
      normalized = normalized.replace(/\./g, "").replace(",", ".");
    } else if (hasComma && !hasDot) {
      normalized = normalized.replace(",", ".");
    }

    normalized = normalized.replace(/[^\d.-]/g, "");
    const num = Number(normalized);
    return Number.isFinite(num) ? num : null;
  }

  const getProdPropRowKey = (prodProp) => {
    if (!prodProp) return null;
    return String(
      prodProp.prodProp_id ??
      prodProp.value ??
      prodProp.prodProp_nome ??
      ""
    );
  }

  const getEventoPagamentoPropRowKey = (eventoPagamentoProp) => {
    if (!eventoPagamentoProp) return null;
    return String(
      eventoPagamentoProp.eventoPagamentoProp_id ??
      eventoPagamentoProp.value ??
      eventoPagamentoProp.eventoPagamentoProp_nome ??
      ""
    );
  }

  const normalizeProdPropOption = (prodProp) => {
    if (!prodProp) return null;

    const value = prodProp.prodProp_id ?? prodProp.value;
    if (value === null || value === undefined) return null;

    return {
      ...prodProp,
      value,
      label: prodProp.prodProp_nome ?? prodProp.label ?? "Sem Nome",
      prodProp_id: value,
      prodProp_nome: prodProp.prodProp_nome ?? prodProp.label ?? "Sem Nome",
    };
  }

  const normalizeEventoPagamentoPropOption = (eventoPagamentoProp) => {
    if (!eventoPagamentoProp) return null;

    const value = eventoPagamentoProp.eventoPagamentoProp_id ?? eventoPagamentoProp.value;
    if (value === null || value === undefined) return null;

    return {
      ...eventoPagamentoProp,
      value,
      label: eventoPagamentoProp.eventoPagamentoProp_nome ?? eventoPagamentoProp.label ?? "Sem Nome",
      eventoPagamentoProp_id: value,
      eventoPagamentoProp_nome: eventoPagamentoProp.eventoPagamentoProp_nome ?? eventoPagamentoProp.label ?? "Sem Nome",
    };
  }

  const eventosPagamentoPropOptions = (propostaData.eventosPagamentoProp || [])
    .map(normalizeEventoPagamentoPropOption)
    .filter(Boolean);

  const prodsPropOptions = (propostaData.prodsProp || [])
    .map(normalizeProdPropOption)
    .filter(Boolean);

  const formatPercent = (value) => {
    const num = parseNumericValue(value);
    if (num === null) return "Sem Valor";

    const formatted = new Intl.NumberFormat("pt-BR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(num);

    return `${formatted}%`;
  }

  const visaoGeralTotal = useMemo(() => {
    const propItensArr = propostaData.propItens || [];

    return propItensArr.reduce((propItensAcc, propItem) => {

      const qtd = parseNumericValue(propItem?.relacaoPropPropItem_propItemQtd) || 0;
      const refVlr = parseNumericValue(propItem?.propItem_refVlr) || 0;
      return propItensAcc + (refVlr * qtd);

    }, 0);
  }, [propostaData.propItens]);

  const visaoGeralPercentualTotal = useMemo(() => {
    const { comissao, custoFinanceiro, taxaAdm, remuneracaoEmpresa } = visaoGeralPercentuais || {};
    return (
      (parseNumericValue(comissao) || 0) +
      (parseNumericValue(custoFinanceiro) || 0) +
      (parseNumericValue(taxaAdm) || 0) +
      (parseNumericValue(remuneracaoEmpresa) || 0)
    );
  }, [visaoGeralPercentuais]);

  const visaoGeralValorFinal = useMemo(() => {
    const base = parseNumericValue(visaoGeralTotal) || 0;
    const pct = parseNumericValue(visaoGeralPercentualTotal) || 0;
    return base * (1 + pct / 100);
  }, [visaoGeralTotal, visaoGeralPercentualTotal]);

  const visaoGeralMesesRows = useMemo(() => {
    const monthsCount = Math.max(0, Number(visaoGeralMesesQtd) || 0);
    const propItens = propostaData.propItens || [];
    const alocacoes = propostaData.propItensAlocacoesPorMes || [];

    return Array.from({ length: monthsCount }, (_, index) => {
      const mesIndice = index + 1;

      const mesValorTotal = propItens.reduce((totalAcc, propItem) => {
        const propItemId = Number(propItem?.propItem_id ?? propItem?.value) || 0;
        if (!propItemId) return totalAcc;

        const alocacao = alocacoes.find(
          (row) => Number(row?.mes_indice) === mesIndice && Number(row?.propItem_id) === propItemId
        );
        const qtdMes = parseNumericValue(alocacao?.relacaoPropPropItemMes_qtd ?? alocacao?.qtd) || 0;
        const valorRef = parseNumericValue(propItem?.propItem_refVlr) || 0;

        return totalAcc + (qtdMes * valorRef);
      }, 0);

      return {
        mes_indice: mesIndice,
        mes_label: `mês ${mesIndice}`,
        mes_valor_total: mesValorTotal,
      };
    });
  }, [visaoGeralMesesQtd, propostaData.propItens, propostaData.propItensAlocacoesPorMes]);

  const columnsVisaoGeralMeses = [
    {
      accessorKey: 'mes_label',
      header: 'Mês',
      size: 100,
      maxWidth: 200,
    },
    {
      accessorKey: 'mes_valor_total',
      header: 'Valor total do mês',
      Cell: ({ row }) => currencyFormatter.format(row.original.mes_valor_total || 0),
    },
  ];

  const propItensAlocacoesPorMes = propostaData.propItensAlocacoesPorMes || [];

  const getQtdPropItemNoMes = (mesIndice, propItemId) => {
    const mes = Number(mesIndice) || 0;
    const itemId = Number(propItemId) || 0;
    if (!mes || !itemId) return 0;

    const alocacao = propItensAlocacoesPorMes.find(
      (row) => Number(row?.mes_indice) === mes && Number(row?.propItem_id) === itemId
    );

    return parseNumericValue(alocacao?.relacaoPropPropItemMes_qtd ?? alocacao?.qtd) || 0;
  };

  const setQtdPropItemNoMes = (mesIndice, propItemId, qtdValue) => {
    const mes = Number(mesIndice) || 0;
    const itemId = Number(propItemId) || 0;
    if (!mes || !itemId) return;

    const qtd = parseNumericValue(qtdValue) || 0;

    setPropostaData((prev) => {
      const current = prev.propItensAlocacoesPorMes || [];
      const rowIndex = current.findIndex(
        (row) => Number(row?.mes_indice) === mes && Number(row?.propItem_id) === itemId
      );

      const next = [...current];

      if (rowIndex >= 0) {
        if (qtd > 0) {
          next[rowIndex] = {
            ...next[rowIndex],
            mes_indice: mes,
            propItem_id: itemId,
            relacaoPropPropItemMes_qtd: qtd,
          };
        } else {
          next.splice(rowIndex, 1);
        }
      } else if (qtd > 0) {
        next.push({
          mes_indice: mes,
          propItem_id: itemId,
          relacaoPropPropItemMes_qtd: qtd,
        });
      }

      return {
        ...prev,
        propItensAlocacoesPorMes: next,
      };
    });
  };

  const getPropItensNoMes = (mesIndice) => {
    const mes = Number(mesIndice) || 0;
    return (propostaData.propItens || []).map((propItem) => {
      const propItemId = Number(propItem?.propItem_id ?? propItem?.value) || 0;
      const qtdMes = getQtdPropItemNoMes(mes, propItemId);
      const valorUnitario = parseNumericValue(
        propItem?.relacaoPropPropItem_vlr ?? propItem?.propItem_refVlr
      ) || 0;

      return {
        ...propItem,
        mes_indice: mes,
        propItem_id: propItemId,
        relacaoPropPropItemMes_qtd: qtdMes,
        relacaoPropPropItemMes_vlr: valorUnitario,
      };
    });
  };

  const getValorTotalNoMes = (mesIndice) => {
    const mes = Number(mesIndice) || 0;
    if (!mes) return 0;

    return (propostaData.propItens || []).reduce((totalAcc, propItem) => {
      const propItemId = Number(propItem?.propItem_id ?? propItem?.value) || 0;
      if (!propItemId) return totalAcc;

      const qtdMes = getQtdPropItemNoMes(mes, propItemId);
      const valorRef = parseNumericValue(propItem?.propItem_refVlr) || 0;

      return totalAcc + (qtdMes * valorRef);
    }, 0);
  };

  const columnsPropItensAlocadosMes = [
    {
      accessorKey: 'propItem_desc',
      header: 'Descrição',
      accessorFn: (row) => row.unidade_label ? `${row.propItem_desc} (${row.unidade_label})` : row.propItem_desc,
    },
    {
      header: 'Qtd. no mês',
      Cell: ({ row }) => (
        <Input
          type="number"
          min={0}
          step="0.01"
          value={String(row.original.relacaoPropPropItemMes_qtd ?? 0)}
          onChange={(e) => {
            setQtdPropItemNoMes(
              row.original.mes_indice,
              row.original.propItem_id,
              e.target.value
            );
          }}
        />
      ),
    },
    {
      header: 'Valor unitário',
      accessorFn: (row) => currencyFormatter.format(row.relacaoPropPropItemMes_vlr ?? 0),
    },
    {
      header: 'Valor total',
      accessorFn: (row) => currencyFormatter.format(
        (parseNumericValue(row.relacaoPropPropItemMes_qtd) || 0) *
        (parseNumericValue(row.relacaoPropPropItemMes_vlr) || 0)
      ),
    },
  ];

  const itensOrcamentariosTotaisPorGrupo = useMemo(() => {
    console.log(propostaData.propItens);
    const propItensArr = propostaData.propItens || [];
    const totais = {
      1: 0, // Recursos Humanos
      4: 0, // Logística
      2: 0, // Equipamentos
      3: 0, // Despesas Gerais
      5: 0, // Subcontratações
    };

    propItensArr.forEach((propItem) => {
      const groupId = Number(propItem?.propItemGr_id);
      if (!Object.prototype.hasOwnProperty.call(totais, groupId)) return;

      const qtd = parseNumericValue(propItem?.relacaoPropPropItem_propItemQtd) || 0;
      const vlr = parseNumericValue(Number(propItem?.propItem_refVlr)) || 0;
      totais[groupId] += (vlr * qtd);
    });

    return totais;
  }, [propostaData.propItens]);

  const columnsSelectedPropPropItens = [
    {
      accessorKey: 'propItem_desc',
      header: 'Descrição',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propItem_desc) {
          return row.propItem_desc + ` (${row.unidade_label})`;
        } else {
          return 'Sem descrição';
        }
      },
    },
    {
      header: 'Quantidade total',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.relacaoPropPropItem_propItemQtd) {
          return row.relacaoPropPropItem_propItemQtd;
        } else {
          return 'Sem quantidade';
        }
      },
    },
    {
      header: 'Valor de referência',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.propItem_refVlr) {
          return currencyFormatter.format(row.propItem_refVlr * row.relacaoPropPropItem_propItemQtd);
        } else {
          return 'Sem valor';
        }
      },
    },
    {
      header: ' ',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <>
          <Button onClick={() => {
            setPropItemData(row.original);
            setModalPropItemEditOpen(true)
          }}>
            Editar
          </Button>
          <Button onClick={() => {
            setPropostaData(
              prev => ({
                ...prev,
                propItens: prev.propItens.filter(pi => pi.propItem_id !== row.original.propItem_id)
              })
            );
          }}>
            Deletar
          </Button>
        </>
      ),
    }
  ]

  const columnsSelectedProdsProp = [
    {
      accessorKey: 'prodProp_nome',
      header: 'Nome',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.prodProp_nome) {
          return row.prodProp_nome;
        } else {
          return 'Sem Nome';
        }
      },
    },
    {
      header: ' ',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <>
          <Button
            onClick={() => {
              console.log(row.original);
              const original = row.original || {};
              setProdPropData({
                ...original,
                prodProp_id: original.prodProp_id ?? original.value,
                prodProp_nome: original.prodProp_nome ?? original.label,
              });
              setIsEditingProdProp(true);
              setModalProdPropOpen(true);
            }}
          >
            Editar
          </Button>
          <Button onClick={() => {
            setPropostaData(
              prev => ({
                ...prev,
                prodsProp: prev.prodsProp.filter(pi => pi.prodProp_id !== row.original.prodProp_id)
              })
            );
          }}>
            Deletar
          </Button>
        </>
      ),
    }
  ]

  const columnsSelectedEventosPagamentoProp = [
    {
      accessorKey: 'eventoPagamentoProp_nome',
      header: 'Nome',
      size: 100,
      maxWidth: 200,
      accessorFn: (row) => {
        if (row.eventoPagamentoProp_nome) {
          return row.eventoPagamentoProp_nome;
        } else {
          return 'Sem Nome';
        }
      },
    },
    {
      accessorKey: 'relacaoServicoEventoPagamentoProp_vlr',
      header: 'Valor (%)',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => formatPercent(row.original.relacaoServicoEventoPagamentoProp_vlr),
    },
    {
      header: ' ',
      size: 100,
      maxWidth: 200,
      Cell: ({ row }) => (
        <>
          <Button
            onClick={() => {
              const original = row.original || {};
              setEventoPagamentoPropData({
                ...original,
                eventoPagamentoProp_id: original.eventoPagamentoProp_id ?? original.value,
                eventoPagamentoProp_nome: original.eventoPagamentoProp_nome ?? original.label,
              });
              setIsEditingEventoPagamentoProp(true);
              setModalEventosPagamentoOpen(true);
            }}
          >
            Editar
          </Button>
          <Button onClick={() => {
            setPropostaData(
              prev => ({
                ...prev,
                eventosPagamentoProp: prev.eventosPagamentoProp.filter(pi => pi.eventoPagamentoProp_id !== row.original.eventoPagamentoProp_id)
              })
            );
          }}>
            Deletar
          </Button>
        </>
      ),
    }
  ]

  const TABS = [
    {
      id: "tab-1",
      label: "Informações gerais",
      subtitle: "Dados gerais da proposta",
      content: (
        <div>
          <h2>Informações gerais</h2>
          <p><strong>Serviço:</strong> {propostaData?.servico_nome || "Sem serviço"}</p>
        </div>
      ),
    },
    {
      id: "tab-2",
      label: "Entidades da proposta",
      subtitle: "Defina itens orçamentários, produtos e eventos de pagamento",
      content: (
        <Tabs>
          <TabList>
            <Tab>Itens orçamentários</Tab>
            <Tab>Produtos</Tab>
            <Tab>Eventos de pagamento</Tab>
          </TabList>
          <TabPanel>
            <Tabs>
              <TabList>
                <Tab>Recursos Humanos</Tab>
                <Tab>Logística</Tab>
                <Tab>Equipamentos</Tab>
                <Tab>Despesas Gerais</Tab>
                <Tab>Subcontratações</Tab>
              </TabList>
              <TabPanel>
                <div className='d-flex justify-content-between align-items-center'>
                  <span>Recursos Humanos</span>
                  <Button
                    size="sm"
                    color="link"
                    className="ml-2 px-0"
                    onClick={(e)=>{
                      setPropItemData({propItemGr_id: 1, propItemGr_label: 'Recurso Humano'});
                      setModalPropItemOpen(true);
                    }}
                  >
                    Adicionar recursos humanos
                  </Button>
                </div>
                <MaterialReactTable
                  columns={columnsSelectedPropPropItens}
                  data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 1) : []}
                  initialState={{
                    density: 'compact',
                    expanded: {}, //expand all groups by default
                    pagination: { pageIndex: 0, pageSize: 10 },
                    sorting: [], //sort by state by default,
                  }}
                  enableColumnResizing={true}
                  enableGrouping={false}
                  enableGlobalFilter={true}
                  enableFilters={true}
                  muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                  muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                  muiTablePaginationProps={{
                    sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                    labelRowsPerPage: <span style={{fontSize: "12px"}}>Recursos humanos por página</span>,
                    rowsPerPageOptions: [10, 50, 100],
                  }}
                  positionPagination='bottom'
                  muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                  enableDensityToggle={false}
                  enableColumnFilters={false}
                  muiTableHeadCellProps={{
                    sx: {
                      '.MuiSvgIcon-root': {fontSize: "18px"},
                      fontSize: '12px',
                      fontWeight: 'normal', // Remove bold text in the header
                      padding: '8px', // Adjust padding to reduce white space
                    },
                  }}
                />
              </TabPanel>
              <TabPanel>
                <div className='d-flex justify-content-between align-items-center'>
                  <span>Logística</span>
                  <Button
                    size="sm"
                    color="link"
                    className="ml-2 px-0"
                    onClick={(e)=>{
                      setPropItemData({propItemGr_id: 4, propItemGr_label: 'Logística'});
                      setModalPropItemOpen(true);
                    }}
                  >
                    Adicionar logística
                  </Button>
                </div>

                <MaterialReactTable
                  columns={columnsSelectedPropPropItens}
                  data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 4) : []}
                  initialState={{
                    density: 'compact',
                    expanded: {}, //expand all groups by default
                    pagination: { pageIndex: 0, pageSize: 10 },
                    sorting: [], //sort by state by default,
                  }}
                  enableColumnResizing={true}
                  enableGrouping={false}
                  enableGlobalFilter={true}
                  enableFilters={true}
                  muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                  muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                  muiTablePaginationProps={{
                    sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                    labelRowsPerPage: <span style={{fontSize: "12px"}}>Log?stica por p?gina</span>,
                    rowsPerPageOptions: [10, 50, 100],
                  }}
                  positionPagination='bottom'
                  muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                  enableDensityToggle={false}
                  enableColumnFilters={false}
                  muiTableHeadCellProps={{
                    sx: {
                      '.MuiSvgIcon-root': {fontSize: "18px"},
                      fontSize: '12px',
                      fontWeight: 'normal', // Remove bold text in the header
                      padding: '8px', // Adjust padding to reduce white space
                    },
                  }}
                />
              </TabPanel>
              <TabPanel>
                <div className='d-flex justify-content-between align-items-center'>
                  <span>Equipamentos</span>
                  <Button
                    size="sm"
                    color="link"
                    className="ml-2 px-0"
                    onClick={(e)=>{
                      setPropItemData({propItemGr_id: 2, propItemGr_label: 'Equipamentos'});
                      setModalPropItemOpen(true);
                    }}
                  >
                    Adicionar equipamentos
                  </Button>
                </div>

                <MaterialReactTable
                  columns={columnsSelectedPropPropItens}
                  data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 2) : []}
                  initialState={{
                    density: 'compact',
                    expanded: {}, //expand all groups by default
                    pagination: { pageIndex: 0, pageSize: 10 },
                    sorting: [], //sort by state by default,
                  }}
                  enableColumnResizing={true}
                  enableGrouping={false}
                  enableGlobalFilter={true}
                  enableFilters={true}
                  muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                  muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                  muiTablePaginationProps={{
                    sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                    labelRowsPerPage: <span style={{fontSize: "12px"}}>Equipamentos por p?gina</span>,
                    rowsPerPageOptions: [10, 50, 100],
                  }}
                  positionPagination='bottom'
                  muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                  enableDensityToggle={false}
                  enableColumnFilters={false}
                  muiTableHeadCellProps={{
                    sx: {
                      '.MuiSvgIcon-root': {fontSize: "18px"},
                      fontSize: '12px',
                      fontWeight: 'normal', // Remove bold text in the header
                      padding: '8px', // Adjust padding to reduce white space
                    },
                  }}
                />
              </TabPanel>
              <TabPanel>
                <div className='d-flex justify-content-between align-items-center'>
                  <span>Despesas Gerais</span>
                  <Button
                    size="sm"
                    color="link"
                    className="ml-2 px-0"
                    onClick={(e)=>{
                      setPropItemData({propItemGr_id: 3, propItemGr_label: 'Despesas gerais'});
                      setModalPropItemOpen(true);
                    }}
                  >
                    Adicionar despesas gerais
                  </Button>
                </div>

                <MaterialReactTable
                  columns={columnsSelectedPropPropItens}
                  data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 3) : []}
                  initialState={{
                    density: 'compact',
                    expanded: {}, //expand all groups by default
                    pagination: { pageIndex: 0, pageSize: 10 },
                    sorting: [], //sort by state by default,
                  }}
                  enableColumnResizing={true}
                  enableGrouping={false}
                  enableGlobalFilter={true}
                  enableFilters={true}
                  muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                  muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                  muiTablePaginationProps={{
                    sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                    labelRowsPerPage: <span style={{fontSize: "12px"}}>Despesas gerais por p?gina</span>,
                    rowsPerPageOptions: [10, 50, 100],
                  }}
                  positionPagination='bottom'
                  muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                  enableDensityToggle={false}
                  enableColumnFilters={false}
                  muiTableHeadCellProps={{
                    sx: {
                      '.MuiSvgIcon-root': {fontSize: "18px"},
                      fontSize: '12px',
                      fontWeight: 'normal', // Remove bold text in the header
                      padding: '8px', // Adjust padding to reduce white space
                    },
                  }}
                />
              </TabPanel>
              <TabPanel>
                <div className='d-flex justify-content-between align-items-center'>
                  <span>Subcontratações</span>
                  <Button
                    size="sm"
                    color="link"
                    className="ml-2 px-0"
                    onClick={(e)=>{
                      setPropItemData({propItemGr_id: 5, propItemGr_label: 'Subcontratações'});
                      setModalPropItemOpen(true);
                    }}
                  >
                    Adicionar subcontratações
                  </Button>
                </div>

                <MaterialReactTable
                  columns={columnsSelectedPropPropItens}
                  data={propostaData.propItens ? propostaData.propItens.filter(pi => Number(pi.propItemGr_id) === 5) : []}
                  initialState={{
                    density: 'compact',
                    expanded: {}, //expand all groups by default
                    pagination: { pageIndex: 0, pageSize: 10 },
                    sorting: [], //sort by state by default,
                  }}
                  enableColumnResizing={true}
                  enableGrouping={false}
                  enableGlobalFilter={true}
                  enableFilters={true}
                  muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                  muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                  muiTablePaginationProps={{
                    sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                    labelRowsPerPage: <span style={{fontSize: "12px"}}>Subcontrata??es por p?gina</span>,
                    rowsPerPageOptions: [10, 50, 100],
                  }}
                  positionPagination='bottom'
                  muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                  enableDensityToggle={false}
                  enableColumnFilters={false}
                  muiTableHeadCellProps={{
                    sx: {
                      '.MuiSvgIcon-root': {fontSize: "18px"},
                      fontSize: '12px',
                      fontWeight: 'normal', // Remove bold text in the header
                      padding: '8px', // Adjust padding to reduce white space
                    },
                  }}
                />
              </TabPanel>
            </Tabs>
            <div style={{ marginTop: "16px" }}>
              <Card>
                <CardHeader>Resumo por grupo</CardHeader>
                <CardBody>
                  <Row className="gy-3">
                    <div className="col-12 col-md-6">
                      <small>Recursos humanos</small>
                      <h5 style={{ margin: 0 }}>
                        {currencyFormatter.format(itensOrcamentariosTotaisPorGrupo[1] || 0)}
                      </h5>
                    </div>
                    <div className="col-12 col-md-6">
                      <small>Logística</small>
                      <h5 style={{ margin: 0 }}>
                        {currencyFormatter.format(itensOrcamentariosTotaisPorGrupo[4] || 0)}
                      </h5>
                    </div>
                    <div className="col-12 col-md-6">
                      <small>Equipamentos</small>
                      <h5 style={{ margin: 0 }}>
                        {currencyFormatter.format(itensOrcamentariosTotaisPorGrupo[2] || 0)}
                      </h5>
                    </div>
                    <div className="col-12 col-md-6">
                      <small>Despesas gerais</small>
                      <h5 style={{ margin: 0 }}>
                        {currencyFormatter.format(itensOrcamentariosTotaisPorGrupo[3] || 0)}
                      </h5>
                    </div>
                    <div className="col-12 col-md-6">
                      <small>Subcontratações</small>
                      <h5 style={{ margin: 0 }}>
                        {currencyFormatter.format(itensOrcamentariosTotaisPorGrupo[5] || 0)}
                      </h5>
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </div>
          </TabPanel>
          <TabPanel>
            <div className='d-flex justify-content-between align-items-center'>
              <span>Produtos</span>
              <Button
                size="sm"
                color="link"
                className="ml-2 px-0"
                onClick={(e)=>{
                  setModalProdPropOpen(true);
                }}
              >
                Adicionar produtos
              </Button>
            </div>
            <MaterialReactTable
              columns={columnsSelectedProdsProp}
              data={propostaData.prodsProp ? propostaData.prodsProp : []}
              initialState={{
                density: 'compact',
                expanded: {}, //expand all groups by default
                pagination: { pageIndex: 0, pageSize: 10 },
                sorting: [], //sort by state by default,
              }}
              enableColumnResizing={true}
              enableGrouping={false}
              enableGlobalFilter={true}
              enableFilters={true}
              muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
              muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
              muiTablePaginationProps={{
                sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
                rowsPerPageOptions: [10, 50, 100],
              }}
              positionPagination='bottom'
              muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
              enableDensityToggle={false}
              enableColumnFilters={false}
              enableExpanding={true}
              renderDetailPanel={({ row }) => {
                const rowData = row.original || {};
                const selectedEventos = (rowData.eventosPagamentoProp || [])
                  .map(normalizeEventoPagamentoPropOption)
                  .filter(Boolean);

                return (
                  <div style={{ padding: "12px 16px", background: "#fafafa" }}>
                    <FormGroup style={{ marginBottom: 0 }}>
                      <span style={{ display: "block", marginBottom: "8px", fontSize: "13px" }}>
                        Vincular eventos de pagamento ao produto
                      </span>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isClearable={true}
                        isSearchable={true}
                        isMulti
                        options={eventosPagamentoPropOptions}
                        value={selectedEventos}
                        onChange={(selected) => {
                          const selectedEventosPagamentoProp = (selected || [])
                            .map(normalizeEventoPagamentoPropOption)
                            .filter(Boolean);

                          const currentRowKey = getProdPropRowKey(rowData);
                          const selectedEventoKeys = new Set(
                            selectedEventosPagamentoProp.map((evento) => getEventoPagamentoPropRowKey(evento)).filter(Boolean)
                          );
                          setPropostaData((prev) => ({
                            ...prev,
                            prodsProp: (prev.prodsProp || []).map((prodProp) => {
                              const prodPropKey = getProdPropRowKey(prodProp);
                              const isCurrentRow =
                                (currentRowKey && prodPropKey && currentRowKey === prodPropKey) ||
                                prodProp === rowData;

                              if (!isCurrentRow) return prodProp;

                              return {
                                ...prodProp,
                                eventosPagamentoProp: selectedEventosPagamentoProp,
                              };
                            }),
                            eventosPagamentoProp: (prev.eventosPagamentoProp || []).map((eventoPagamentoProp) => {
                              const eventoKey = getEventoPagamentoPropRowKey(eventoPagamentoProp);
                              if (!eventoKey) return eventoPagamentoProp;

                              const currentEventoProds = (eventoPagamentoProp.prodsProp || [])
                                .map(normalizeProdPropOption)
                                .filter(Boolean);
                              const currentEventoProdKeys = new Set(
                                currentEventoProds.map((prod) => getProdPropRowKey(prod)).filter(Boolean)
                              );

                              if (selectedEventoKeys.has(eventoKey)) {
                                if (currentRowKey) currentEventoProdKeys.add(currentRowKey);
                              } else {
                                if (currentRowKey) currentEventoProdKeys.delete(currentRowKey);
                              }

                              const normalizedProds = (prev.prodsProp || [])
                                .map(normalizeProdPropOption)
                                .filter((prod) => {
                                  const prodKey = getProdPropRowKey(prod);
                                  return prodKey && currentEventoProdKeys.has(prodKey);
                                });

                              return {
                                ...eventoPagamentoProp,
                                prodsProp: normalizedProds,
                              };
                            }),
                          }));
                        }}
                      />
                    </FormGroup>
                  </div>
                );
              }}
              muiTableHeadCellProps={{
                sx: {
                  '.MuiSvgIcon-root': {fontSize: "18px"},
                  fontSize: '12px',
                  fontWeight: 'normal', // Remove bold text in the header
                  padding: '8px', // Adjust padding to reduce white space
                },
              }}
            />
          </TabPanel>
          <TabPanel>
            <div className='d-flex justify-content-between align-items-center'>
              <span>Eventos pagamento</span>
              <Button
                size="sm"
                color="link"
                className="ml-2 px-0"
                onClick={(e)=>{
                  setModalEventosPagamentoOpen(true);
                }}
              >
                Adicionar eventos pagamento
              </Button>
            </div>
            <MaterialReactTable
              columns={columnsSelectedEventosPagamentoProp}
              data={propostaData.eventosPagamentoProp ? propostaData.eventosPagamentoProp : []}
              initialState={{
                density: 'compact',
                expanded: {}, //expand all groups by default
                pagination: { pageIndex: 0, pageSize: 10 },
                sorting: [], //sort by state by default,
              }}
              enableColumnResizing={true}
              enableGrouping={false}
              enableGlobalFilter={true}
              enableFilters={true}
              muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
              muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
              muiTablePaginationProps={{
                sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                labelRowsPerPage: <span style={{fontSize: "12px"}}>Eventos por página</span>,
                rowsPerPageOptions: [10, 50, 100],
              }}
              positionPagination='bottom'
              muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
              enableDensityToggle={false}
              enableColumnFilters={false}
              enableExpanding={true}
              renderDetailPanel={({ row }) => {
                const rowData = row.original || {};
                const selectedProds = (rowData.prodsProp || [])
                  .map(normalizeProdPropOption)
                  .filter(Boolean);

                return (
                  <div style={{ padding: "12px 16px", background: "#fafafa" }}>
                    <FormGroup style={{ marginBottom: 0 }}>
                      <span style={{ display: "block", marginBottom: "8px", fontSize: "13px" }}>
                        Vincular produtos ao evento de pagamento
                      </span>
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        isClearable={true}
                        isSearchable={true}
                        isMulti
                        options={prodsPropOptions}
                        value={selectedProds}
                        onChange={(selected) => {
                          const selectedProdsProp = (selected || [])
                            .map(normalizeProdPropOption)
                            .filter(Boolean);

                          const currentRowKey = getEventoPagamentoPropRowKey(rowData);
                          const selectedProdKeys = new Set(
                            selectedProdsProp.map((prod) => getProdPropRowKey(prod)).filter(Boolean)
                          );
                          setPropostaData((prev) => ({
                            ...prev,
                            eventosPagamentoProp: (prev.eventosPagamentoProp || []).map((eventoPagamentoProp) => {
                              const eventoPagamentoPropKey = getEventoPagamentoPropRowKey(eventoPagamentoProp);
                              const isCurrentRow =
                                (currentRowKey && eventoPagamentoPropKey && currentRowKey === eventoPagamentoPropKey) ||
                                eventoPagamentoProp === rowData;

                              if (!isCurrentRow) return eventoPagamentoProp;

                              return {
                                ...eventoPagamentoProp,
                                prodsProp: selectedProdsProp,
                              };
                            }),
                            prodsProp: (prev.prodsProp || []).map((prodProp) => {
                              const prodKey = getProdPropRowKey(prodProp);
                              if (!prodKey) return prodProp;

                              const currentProdEventos = (prodProp.eventosPagamentoProp || [])
                                .map(normalizeEventoPagamentoPropOption)
                                .filter(Boolean);
                              const currentProdEventoKeys = new Set(
                                currentProdEventos.map((evento) => getEventoPagamentoPropRowKey(evento)).filter(Boolean)
                              );

                              if (selectedProdKeys.has(prodKey)) {
                                if (currentRowKey) currentProdEventoKeys.add(currentRowKey);
                              } else {
                                if (currentRowKey) currentProdEventoKeys.delete(currentRowKey);
                              }

                              const normalizedEventos = (prev.eventosPagamentoProp || [])
                                .map(normalizeEventoPagamentoPropOption)
                                .filter((evento) => {
                                  const eventoKey = getEventoPagamentoPropRowKey(evento);
                                  return eventoKey && currentProdEventoKeys.has(eventoKey);
                                });

                              return {
                                ...prodProp,
                                eventosPagamentoProp: normalizedEventos,
                              };
                            }),
                          }));
                        }}
                      />
                    </FormGroup>
                  </div>
                );
              }}
              muiTableHeadCellProps={{
                sx: {
                  '.MuiSvgIcon-root': {fontSize: "18px"},
                  fontSize: '12px',
                  fontWeight: 'normal', // Remove bold text in the header
                  padding: '8px', // Adjust padding to reduce white space
                },
              }}
            />
          </TabPanel>
        </Tabs>
      ),
    },
    {
      id: "tab-3",
      label: "Visão geral",
      subtitle: "Resumo dos itens",
      content: (
        <div>
          <FormGroup>
            <span>Quantidade de meses da proposta</span>
            <Input
              type="number"
              min={0}
              value={visaoGeralMesesQtd}
              onChange={(e) => setVisaoGeralMesesQtd(Math.max(0, Number(e.target.value) || 0))}
            />
          </FormGroup>

          <MaterialReactTable
            columns={columnsVisaoGeralMeses}
            data={visaoGeralMesesRows}
            initialState={{
              density: 'compact',
              expanded: {},
              pagination: { pageIndex: 0, pageSize: 10 },
              sorting: [],
            }}
            enableColumnResizing={true}
            enableGrouping={false}
            enableGlobalFilter={true}
            enableFilters={true}
            muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
            muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
            muiTablePaginationProps={{
              sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
              labelRowsPerPage: <span style={{fontSize: "12px"}}>Meses por página</span>,
              rowsPerPageOptions: [10, 50, 100],
            }}
            positionPagination='bottom'
            muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
            enableDensityToggle={false}
            enableColumnFilters={false}
            enableExpanding={true}
            renderDetailPanel={({ row }) => {
              const mesIndice = Number(row.original?.mes_indice) || 0;
              const dataMes = getPropItensNoMes(mesIndice);

              return (
                <div style={{ padding: "8px 16px" }}>
                  <MaterialReactTable
                    columns={columnsPropItensAlocadosMes}
                    data={dataMes}
                    initialState={{
                      density: 'compact',
                      pagination: { pageIndex: 0, pageSize: 10 },
                      sorting: [],
                    }}
                    enableColumnResizing={true}
                    enableGrouping={false}
                    enableGlobalFilter={true}
                    enableFilters={true}
                    muiTopToolbarProps={{sx: {'.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"}, '.MuiSvgIcon-root': {width: '12px'}, '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}}}}
                    muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
                    muiTablePaginationProps={{
                      sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
                      labelRowsPerPage: <span style={{fontSize: "12px"}}>Itens por página</span>,
                      rowsPerPageOptions: [10, 50, 100],
                    }}
                    positionPagination='bottom'
                    muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
                    enableDensityToggle={false}
                    enableColumnFilters={false}
                    muiTableHeadCellProps={{
                      sx: {
                        '.MuiSvgIcon-root': {fontSize: "18px"},
                        fontSize: '12px',
                        fontWeight: 'normal',
                        padding: '8px',
                      },
                    }}
                  />
                </div>
              );
            }}
            muiTableHeadCellProps={{
              sx: {
                '.MuiSvgIcon-root': {fontSize: "18px"},
                fontSize: '12px',
                fontWeight: 'normal',
                padding: '8px',
              },
            }}
          />

          <Card>
            <CardHeader onClick={() => console.log(visaoGeralTotal)}>
              Total de itens selecionados
            </CardHeader>
            <CardBody>
              <Row className="gy-3">
                <div className="col-12">
                  <div>
                    <small>Total (base)</small>
                    <h3 style={{ margin: 0 }}>
                      {currencyFormatter.format(visaoGeralTotal || 0)}
                    </h3>
                  </div>
                </div>

                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>Comissão (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.comissao ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          comissao: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>

                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>Custo financeiro (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.custoFinanceiro ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          custoFinanceiro: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>

                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>Taxa ADM (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.taxaAdm ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          taxaAdm: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>

                <div className="col-12 col-md-6">
                  <FormGroup>
                    <span>Remuneração da empresa (%)</span>
                    <MaskedInput
                      unmask
                      mask="num %"
                      blocks={{
                        num: {
                          mask: Number,
                          scale: 2,
                          signed: false,
                          thousandsSeparator: '.',
                          padFractionalZeros: false,
                          normalizeZeros: false,
                          radix: ',',
                          min: 0,
                          max: 100,
                        },
                      }}
                      lazy={false}
                      value={String(visaoGeralPercentuais.remuneracaoEmpresa ?? "")}
                      onAccept={(value) => {
                        setVisaoGeralPercentuais((prev) => ({
                          ...prev,
                          remuneracaoEmpresa: parseNumericValue(value) || 0,
                        }));
                      }}
                    />
                  </FormGroup>
                </div>

                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-end">
                    <div>
                      <small>Total de percentuais</small>
                      <div style={{ fontWeight: 600 }}>
                        {formatPercent(visaoGeralPercentualTotal)}
                      </div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <small>Valor final</small>
                      <h3 style={{ margin: 0 }}>
                        {currencyFormatter.format(visaoGeralValorFinal || 0)}
                      </h3>
                    </div>
                  </div>
                </div>
              </Row>
              <small>
                Soma de (valor de referência × quantidade) em todas as macroatividades selecionadas.
              </small>
            </CardBody>
          </Card>
        </div>
      ),
    },
  ];

  const activeTab = TABS.find((tab) => tab.id === activeId);

  const fetchProdsProp = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'prodProp',
        data: {
          prodProp_ativo: 1,
        },
        fields: {
          prodProp_id: 'value',
          prodProp_nome: 'label'
        }
      })}`
    )

    setProdsProp(res.data);
  }

  const fetchEventosPagamento = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'eventoPagamentoProp',
        data: {
          eventoPagamentoProp_ativo: 1,
        },
        fields: {
          eventoPagamentoProp_id: 'value',
          eventoPagamentoProp_nome: 'label'
        }
      })}`
    )

    setEventosPagamentoProp(res.data);
  }

  const fetchItensOrcamentarios = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'propItem',
        data: {
          propItem_ativo: 1,
        },
        fields: {
          propItem_id : "value",
          "(CONCAT(propItem_desc, ' (', unidade_label, ')'))": 'label'
        }
      })}`
    )

    setPropItens(res.data)
  }

  const fetchServicos = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'servico',
        data: {
          servico_ativo: 1,
        },
        fields: {
          servico_id: 'value',
          servico_nome: 'label'
        }
      })}`
    )

    setServicos([...res.data]);
  }

  const fetchPropostaData = async () => {
    const res = await oikosApi.get(
      `/?${qs.stringify({
        action: 'get',
        table: 'negociacao',
        data: {
          negociacao_id: Number(id),
          negociacao_ativo: 1,
        },
        fields: {
          negociacao_id: 'value',
          negociacao_nome: 'label',
          '(SELECT servico_nome FROM servico WHERE servico_id = negociacao.servico_id)': 'servico_nome'
        }
      })}`
    )

    console.log(res.data[0]);

    setPropostaData(prev => ({...prev, ...res.data[0]}))
  }

  useEffect(() => {
    fetchPropostaData();
    fetchProdsProp();
    fetchEventosPagamento();
    fetchItensOrcamentarios();
    fetchServicos();
    setActiveId(TABS[0].id);
  }, [])

  return (
    <div style={{padding: '10rem'}} className="timeline-tabs">
      {/* LEFT: timeline tabs */}
      <aside className="timeline-tabs__sidebar">
        <ul className="timeline">
          {TABS.map((tab, index) => (
            <li
              key={tab.id}
              className={
                "timeline__item" +
                (tab.id === activeId ? " timeline__item--active" : "") +
                (index === 0 ? " timeline__item--first" : "") +
                (index === TABS.length - 1 ? " timeline__item--last" : "")
              }
            >
              <button
                type="button"
                className="timeline__button"
                onClick={() => setActiveId(tab.id)}
              >
                <span className="timeline__marker" />
                <div className="timeline__text">
                  <span className="timeline__label">{tab.label}</span>
                  {tab.subtitle && (
                    <span className="timeline__subtitle">
                      {tab.subtitle}
                    </span>
                  )}
                </div>
              </button>
            </li>
          ))}
        </ul>
      </aside>

      {/* RIGHT: content */}
      <section className="timeline-tabs__content">
        {activeTab?.content}
      </section>

      <Modal
        centered={false}
        isOpen={modalPropItemOpen}
        toggle={() => setModalPropItemOpen(false)}
      >
        <ModalHeader>Adicionar {propItemData.propItemGr_label}</ModalHeader>

        <ModalBody>

          <FormGroup>
            <span>
              Selecione o item orçamentário
            </span>
            <Select
              className="basic-single"
              classNamePrefix="select"
              isClearable={true}
              isSearchable={true}
              value={propItens.find(pi => pi.value === propItemData.value)}
              options={propItens.filter(pi => pi.propItemGr_id === propItemData.propItemGr_id)}
              onChange={async (e) => {
                if (e) {
                  setPropItemData({ ...e })
                } else {
                  setPropItemData({})
                }
              }}
            />
          </FormGroup>

          <FormGroup>
            <span>
              Valor unitário
            </span>
            <MaskedInput
              disabled={true}
              unmask
              mask="R$ num"
              blocks={{
                num: {
                  mask: Number,
                  scale: 2, // digits after point 0 for integers
                  signed: false, // disallow negative
                  thousandsSeparator: '.', // any single char
                  padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                  normalizeZeros: false, // appends or removes zeros at ends
                  radix: ',', // fractional delimiter
                  min: 0,
                  max: 1000000000,
                },
              }}
              lazy={false}
              value={String(propItemData.propItem_refVlr)}
              onAccept={value => setPropItemData({...propItemData, propItem_refVlr: value})}
            />
          </FormGroup>

          <FormGroup>
            <span>
              Quantidade
            </span>
            <Input
              value={propItemData.relacaoMacroatividadePropItem_propItemQtd}
              onChange={async (e) => {
                if (propItemData.propItem_id) {
                  setPropItemData({ ...propItemData, relacaoPropPropItem_propItemQtd: Number(e.target.value) })
                }
              }}
            />
          </FormGroup>

        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            onClick={() => setModalPropItemOpen(false)}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>

          {isSubmitEntityLoading ? (
            <Button type="button" disabled>
              <Spinner />
            </Button>
          ) : (
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={() => {
                setIsSubmitEntityLoading(true);
                const finded = propostaData.propItens?.find(pi => pi.propItem_id === propItemData.value);
                if (finded) {
                  setPropostaData(
                    {
                      ...propostaData,
                      propItens: [
                        ...propostaData.propItens.filter(pi => pi.propItem_id !== propItemData.propItem_id),
                        {
                          ...propItemData,
                          propItem_id: finded.propItem_id,
                          relacaoPropPropItem_id: finded.relacaoPropPropItem_id,
                          relacaoPropPropItem_propItemQtd: (propItemData.relacaoPropPropItem_propItemQtd + Number(finded.relacaoPropPropItem_propItemQtd)),
                          prop_id: finded.prop_id,
                        }
                      ]
                    }
                  );
                } else {
                  setPropostaData({...propostaData, propItens: [...(propostaData.propItens ? propostaData.propItens : []), propItemData]});
                }
                setIsSubmitEntityLoading(false);
                setModalPropItemOpen(false)
              }}
            >
              Salvar
            </Button>
          )}
        </ModalFooter>
      </Modal>

      <Modal
        centered={false}
        isOpen={modalProdPropOpen}
        toggle={() => {
          setModalProdPropOpen(false);
          setProdPropData({});
        }}
      >
        <ModalHeader>{isEditingProdProp ? 'Editar Produto' : 'Adicionar Produto'}</ModalHeader>

        <ModalBody>

          <Tabs>
            <TabList>
              {!isEditingProdProp && <Tab>Modelo de produto</Tab>}
              <Tab>{isEditingProdProp ? 'Editar produto' : 'Novo produto'}</Tab>
            </TabList>
            {!isEditingProdProp && <TabPanel>
              <FormGroup>
                <span>
                  Modelo de produto
                </span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  options={prodsProp}
                  onChange={async (e) => {
                    setProdPropData(e)
                  }}
                />
              </FormGroup>
            </TabPanel>}
            <TabPanel>
              <FormGroup>
                <span>
                  Nome do produto
                </span>
                <Input
                  value={prodPropData.prodProp_nome || ""}
                  onChange={e => setProdPropData({...prodPropData, prodProp_nome: e.target.value})}
                />
              </FormGroup>
            </TabPanel>
          </Tabs>

        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            onClick={() => {
              setModalProdPropOpen(false);
              setProdPropData({});
              setIsEditingProdProp(false);
            }}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>

          {isSubmitEntityLoading ? (
            <Button type="button" disabled>
              <Spinner />
            </Button>
          ) : (
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={async () => {
                if (isEditingProdProp) {
                  console.log(propostaData.prodsProp, prodPropData, propostaData.prodsProp.filter(pp => pp.prodProp_id !== prodPropData.prodProp_id));
                  setPropostaData({...propostaData, prodsProp: [...(propostaData.prodsProp ? propostaData.prodsProp.filter(pp => pp.prodProp_id !== prodPropData.prodProp_id) : []), prodPropData]})
                } else {
                  setPropostaData({...propostaData, prodsProp: [...(propostaData.prodsProp ? propostaData.prodsProp : []), prodPropData]})
                }
                setModalProdPropOpen(false);
                setIsEditingProdProp(false);
                setProdPropData({});
                setIsSubmitEntityLoading(false);
              }}
            >
              Salvar
            </Button>
          )}
        </ModalFooter>
      </Modal>

      <Modal
        centered={false}
        isOpen={modalEventosPagamentoOpen}
        toggle={() => {
          setModalEventosPagamentoOpen(false);
          setEventoPagamentoPropData({});
          setIsEditingEventoPagamentoProp(false);
        }}
      >
        <ModalHeader>{isEditingEventoPagamentoProp ? 'Editar evento de pagamento' : 'Adicionar evento de pagamento'}</ModalHeader>

        <ModalBody>

          <Tabs>
            <TabList>
              {!isEditingEventoPagamentoProp && <Tab>Modelo de evento de pagamento</Tab>}
              <Tab>{isEditingEventoPagamentoProp ? 'Editar evento de pagamento' : 'Novo evento de pagamento'}</Tab>
            </TabList>
            {!isEditingEventoPagamentoProp && <TabPanel>
              <FormGroup>
                <span>
                  Modelo de evento de pagamento
                </span>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  isSearchable={true}
                  options={eventosPagamentoProp}
                  onChange={async (e) => {
                    setEventoPagamentoPropData(e);
                  }}
                />
              </FormGroup>
            </TabPanel>}
            <TabPanel>
              <FormGroup>
                <span>
                  Nome do evento de pagamento
                </span>
                <Input
                  value={eventoPagamentoPropData.eventoPagamentoProp_nome || ""}
                  onChange={e => setEventoPagamentoPropData({...eventoPagamentoPropData, eventoPagamentoProp_nome: e.target.value})}
                />
              </FormGroup>

              <FormGroup>
                <span>Valor (%)</span>
                <MaskedInput
                  unmask
                  mask="num %"
                  blocks={{
                    num: {
                      mask: Number,
                      scale: 2, // digits after point 0 for integers
                      signed: false, // disallow negative
                      thousandsSeparator: '.', // any single char
                      padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                      normalizeZeros: false, // appends or removes zeros at ends
                      radix: ',', // fractional delimiter
                      min: 0,
                      max: 100,
                    },
                  }}
                  lazy={false}
                  value={String(eventoPagamentoPropData.relacaoServicoEventoPagamentoProp_vlr || "")}
                  onAccept={value => {
                    setEventoPagamentoPropData({...eventoPagamentoPropData, relacaoServicoEventoPagamentoProp_vlr: Number(value)});
                  }}
                />
              </FormGroup>
            </TabPanel>
          </Tabs>

        </ModalBody>

        <ModalFooter>
          <Button
            type="button"
            onClick={() => {
              setModalEventosPagamentoOpen(false);
              setEventoPagamentoPropData({});
              setIsEditingEventoPagamentoProp(false);
            }}
            color="light"
            className="waves-effect"
          >
            Cancelar
          </Button>

          {isSubmitEntityLoading ? (
            <Button type="button" disabled>
              <Spinner />
            </Button>
          ) : (
            <Button
              type="button"
              color="primary"
              className="waves-effect waves-light"
              onClick={async () => {
                if (isEditingEventoPagamentoProp) {
                  setPropostaData({...propostaData, eventosPagamentoProp: [...(propostaData.eventosPagamentoProp ? propostaData.eventosPagamentoProp.filter(pp => pp.eventoPagamentoProp_id !== eventoPagamentoPropData.eventoPagamentoProp_id) : []), eventoPagamentoPropData]})
                } else {
                  setPropostaData({...propostaData, eventosPagamentoProp: [...(propostaData.eventosPagamentoProp ? propostaData.eventosPagamentoProp : []), eventoPagamentoPropData]})
                }
                setModalEventosPagamentoOpen(false);
                setIsEditingEventoPagamentoProp(false);
                setEventoPagamentoPropData({});
                setIsSubmitEntityLoading(false);
              }}
            >
              Salvar
            </Button>
          )}
        </ModalFooter>
      </Modal>

      {
        Object.keys(propostaData).length > 0 && Object.keys(propItemData).length > 0 &&
        <Modal
          centered={false}
          isOpen={modalPropItemEditOpen}
          toggle={() => setModalPropItemEditOpen(false)}
        >
          <ModalHeader>Edição {propItemData.propItemGr_label}</ModalHeader>

          <ModalBody>
            <FormGroup>
              <span>
                Selecione o item orçamentário
              </span>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isDisabled={true}
                value={propItens.find((pi) => {
                  return pi.propItem_id === propItemData.propItem_id;
                })}
              />
            </FormGroup>

            <FormGroup>
              <span>
                Valor unitário
              </span>
              <MaskedInput
                unmask
                disabled={true}
                mask="R$ num"
                blocks={{
                  num: {
                    mask: Number,
                    scale: 2, // digits after point 0 for integers
                    signed: false, // disallow negative
                    thousandsSeparator: '.', // any single char
                    padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                    normalizeZeros: false, // appends or removes zeros at ends
                    radix: ',', // fractional delimiter
                    min: 0,
                    max: 1000000000,
                  },
                }}
                lazy={false}
                value={String(propItemData.propItem_refVlr)}
                onAccept={value => setPropItemData({...propItemData, propItem_refVlr: value})}
              />
            </FormGroup>

            <FormGroup>
              <span>
                Quantidade
              </span>
              <Input
              value={propItemData.relacaoPropPropItem_propItemQtd}
                onChange={async (e) => {
                  if (propItemData.propItem_id) {
                    if (e.target.value && e.target.value !== '' && !isNaN(Number(e.target.value))) {
                      setPropItemData({
                        ...propItemData,
                        relacaoPropPropItem_propItemQtd: Number(e.target.value)
                      })
                    }
                    else {
                      setPropItemData({
                        ...propItemData,
                        relacaoPropPropItem_propItemQtd: 0
                      })
                    }
                  }
                }}
              />
            </FormGroup>

          </ModalBody>

          <ModalFooter>
            <Button
              type="button"
              onClick={() => setModalPropItemEditOpen(false)}
              color="light"
              className="waves-effect"
            >
              Cancelar
            </Button>

            {isSubmitEntityLoading ? (
              <Button type="button" disabled>
                <Spinner />
              </Button>
            ) : (
              <Button
                type="button"
                color="primary"
                className="waves-effect waves-light"
                onClick={()=>{
                  setIsSubmitEntityLoading(true);
                  setPropostaData({...propostaData, propItens: propostaData.propItens.map(pi => {
                    if (pi.propItem_id === propItemData.propItem_id) {
                      return propItemData;
                    } else {
                      return pi;
                    }
                  })});
                  setPropItemData({});
                  setIsSubmitEntityLoading(false);
                  setModalPropItemEditOpen(false);
                }}
              >
                Salvar
              </Button>
            )}
          </ModalFooter>
        </Modal>
      }
    </div>
  )
}

export default NovaPropostaEmBranco
